import React, { useEffect, useState } from "react";
import { griData } from "./griData";
import { tcfdData } from "./tcfdData";
import { gstcData } from "./gstcData";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import DisclosureCollapse from "./DisclosureCollapse";
import {
  Button,
  Dialog,
  FormControlLabel,
  FormGroup,
  IconButton,
  Checkbox,
  Collapse,
} from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";
import CancelIcon from "@mui/icons-material/Cancel";
import { green } from "../../../constants/colorConstants";
import "./Disclosures.scss";
import {
  addDisclosure,
  downloadGRIIndex,
  getDisclosure,
  updateDisclosure,
} from "../../../services/orgService";
import { toastMessage } from "../../../helper";
import { ExpandMore } from "@mui/icons-material";
import { brsrData } from "./brsrData";
const Disclosures = (props: any) => {
  let [year, setYear] = useState(new Date().getFullYear());
  let [disclosures, setDisclosures] = useState<any>(null);
  let [disclosuresArray, setDisclosuresArray] = useState<any[]>([]);
  let [disclosureType, setDisclosureType] = useState("gri");
  const [disclaimerExpanded, setDisclaimerExpanded] = React.useState(true);
  const onDateChange = (date: any) => {
    setYear(date.$y);
  };

  const getGRIIndex = () => {
    downloadGRIIndex(year).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Report.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
      toastMessage("Report downloaded", "sucess");
    });
  };

  useEffect(() => {
    getDisclosure(year, props.reportName)
      .then((res) => {
        if (res.data.data) {
          let parsedData = JSON.parse(res.data.data);
          setIsUpdate(true);
          if (props.reportName == "gri") {
            if (
              !parsedData["GRI 3: Material Topics 2021"][
                "3-3 Management of material topics"
              ]["topics"]
            ) {
              let obj =
                parsedData["GRI 3: Material Topics 2021"][
                  "3-3 Management of material topics"
                ];
              obj = {
                comments: obj.comments,
                attachments: [],
                topics: {},
              };
              parsedData["GRI 3: Material Topics 2021"][
                "3-3 Management of material topics"
              ] = obj;
            }
            if (
              parsedData["GRI 3: Material Topics 2021"][
                "3-3 Management of material topics"
              ].attachments == ""
            ) {
              parsedData["GRI 3: Material Topics 2021"][
                "3-3 Management of material topics"
              ].attachments = [];
            }
            setDisclosuresArray([
              ...Object.keys(parsedData).slice(0, 2),
              ...parsedData["GRI 3: Material Topics 2021"][
                "3-2 List of material topics"
              ]["a. list its material topics;"][1]
                .filter((item: any) => item.included)
                .map((item: any) => item.name),
            ]);
          }
          if (props.reportName == "gstc") {
            let set = new Set();
            Object.keys(parsedData)
              .map((key) => key.split("-")[0].trim())
              .forEach((item) => set.add(item));
            gstcMap = {
              Hotels: false,
              "Tour Operators": false,
              Destinations: false,
            };
            set.forEach((item: any) => {
              gstcMap[item] = true;
            });
            setGstcMap({ ...gstcMap });
          }
          setDisclosures(parsedData);
        }
      })
      .catch((e) => {
        setIsUpdate(false);
        gstcMap = {
          Hotels: false,
          "Tour Operators": false,
          Destinations: false,
        };
        setGstcMap(gstcMap);
        let disclosures =
          props.reportName === "gri"
            ? griData
            : props.reportName === "tcfd"
            ? tcfdData
            : props.reportName === "gstc"
            ? gstcData
            : brsrData;

        let filteredDisclosures = Object.keys(disclosures);
        if (props.reportName === "gri") {
          filteredDisclosures = filteredDisclosures.slice(0, 2);
        }
        if (props.reportName == "gstc") {
          disclosures = {};
        }
        setDisclosures(JSON.parse(JSON.stringify(disclosures)));
        setDisclosuresArray(filteredDisclosures);
      });
  }, [year]);

  let [gstcMap, setGstcMap] = useState<any>({
    Hotels: false,
    "Tour Operators": false,
    Destinations: false,
  });
  useEffect(() => {
    setDisclosureType(props.reportName);
    let disclosures =
      props.reportName === "gri"
        ? griData
        : props.reportName === "tcfd"
        ? tcfdData
        : props.reportName === "gstc"
        ? gstcData
        : brsrData;

    let filteredDisclosures = Object.keys(disclosures);
    if (props.reportName === "gri") {
      filteredDisclosures = filteredDisclosures.slice(0, 2);
    }
    if (props.reportName === "gstc") {
      disclosures = {};
    }
    setDisclosures(JSON.parse(JSON.stringify(disclosures)));
    setDisclosuresArray(filteredDisclosures);
  }, []);

  let [openDialog, setOpenDialog] = useState(false);

  const checkDisclosureEmpty = (disclosure: any) => {
    let isEmpty = false;
    Object.keys(disclosure).forEach((key: string) => {
      if (key != "attachments" && key != "comments") {
        if (disclosure[key] instanceof Array) {
          if (disclosure[key][0] != "table") {
            if (["", null, undefined].includes(disclosure[key][1])) {
              isEmpty = true;
            }
          } else {
            if (disclosure[key][1].length == 0) isEmpty = true;
            else {
              disclosure[key][1].forEach((row: any) => {
                Object.values(row).forEach((ans) => {
                  if (ans == "" || ans == null || ans == undefined)
                    isEmpty = true;
                });
              });
            }
          }
        } else {
          if (checkDisclosureEmpty(disclosure[key])) {
            isEmpty = true;
          }
        }
      }
    });
    return isEmpty;
  };

  const handleSave = () => {
    if (disclosureType == "gri") {
      let topics = disclosures["GRI 3: Material Topics 2021"][
        "3-2 List of material topics"
      ]["a. list its material topics;"][1].filter((item: any) => item.included);
      let isReturn = false;
      topics.forEach((topic: any) => {
        let isIncomplete = false;
        Object.keys(disclosures[topic.name]).forEach((el: string) => {
          if (checkDisclosureEmpty(disclosures[topic.name][el])) {
            if (!disclosures[topic.name][el].comments.reasonType) {
              // toastMessage(el.split(" ")[0]+" is incomplete. Please fill the data for provide a omission reason.","error");
              isIncomplete = true;
              isReturn = true;
            }
          }
        });
        if (isIncomplete && !topic.comments && topic.comments.reasonType) {
          toastMessage(
            topic.split(":")[0] +
              " is incomplete. Please fill the data or provide a omission reason.",
            "error"
          );
        } else {
          isReturn = false;
        }
      });
      if (isReturn) return;
    }
    let disclosureData = {
      year: year,
      reportType: disclosureType,
      data: JSON.stringify(disclosures),
    };
    if (isUpdate) {
      updateDisclosure(disclosureData).then((res) => {
        if (res.data.success) {
          toastMessage("Disclosure updated successfully", "success");
        }
      });
    } else {
      addDisclosure(disclosureData).then((res) => {
        if (res.data.success) {
          toastMessage("Disclosure added successfully", "success");
          setIsUpdate(true);
        }
      });
    }
  };
  let [enableSave, setEnableSave] = useState(false);
  let [isUpdate, setIsUpdate] = useState(false);
  const updateUi = () => {
    setDisclosures(JSON.parse(JSON.stringify(disclosures)));
    setEnableSave(true);
  };

  const changeDisclosureData = (industry: string) => {
    gstcMap[industry] = !gstcMap[industry];
    setGstcMap({ ...gstcMap });
    let map: any = {};
    if (gstcMap[industry]) {
      Object.keys(gstcData).forEach((item) => {
        if (item.startsWith(industry)) {
          map[item] = JSON.parse(JSON.stringify(gstcData[item]));
        }
      });
      let tempMap = JSON.parse(JSON.stringify({ ...disclosures, ...map }));
      let tempKeys = Object.keys(tempMap);
      let finalMap: any = {};
      ["Hotels", "Tour Operators", "Destinations"].forEach((key) => {
        tempKeys.forEach((level) => {
          if (level.startsWith(key)) {
            finalMap[level] = JSON.parse(JSON.stringify(gstcData[level]));
          }
        });
      });
      disclosures = finalMap;
    } else {
      Object.keys(disclosures).forEach((item) => {
        if (item.startsWith(industry)) {
          delete disclosures[item];
        }
      });
    }
    updateUi();
  };
  return (
    <>
      {disclosures ? (
        <div style={{ position: "relative", height: "calc( 100vh - 142px )" }}>
          <div
            style={{
              overflow: "auto",
              paddingLeft: "2vw",
              height:
                props.reportName === "gri"
                  ? disclaimerExpanded
                    ? "calc( 100vh - 118px - 52px - 220px - 24px )"
                    : "calc( 100vh - 118px - 52px - 24px )"
                  : "calc(100vh - 250px)",
            }}
          >
            <DatePicker
              style={{ marginTop: "2vh" }}
              picker="year"
              defaultValue={dayjs(new Date())}
              onChange={onDateChange}
            />
            {props.reportName == "gri" ? (
              <img
                src="assets/images/GRI-LM-2025.png"
                alt="GRI"
                className="w-28 h-28 cursor-pointer mr-2.5 mt-1.5"
                style={{ position: "fixed", top: "100px", right: "30px" }}
                // onClick={() =>
                //   window.open(
                //     "https://www.globalreporting.org/how-to-use-the-gri-standards/resource-center/",
                //     "_blank"
                //   )
                // }
              />
            ) : (
              ""
            )}
            {props.reportName == "gstc" ? (
              <>
                <br />
                <br />
                <FormGroup sx={{ flexDirection: "row", paddingLeft: "2vw" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={gstcMap["Hotels"]}
                        onChange={(e) => changeDisclosureData("Hotels")}
                      />
                    }
                    label="Hotels"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={gstcMap["Tour Operators"]}
                        onChange={(e) => changeDisclosureData("Tour Operators")}
                      />
                    }
                    label="Tour Operators"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={gstcMap["Destinations"]}
                        onChange={(e) => changeDisclosureData("Destinations")}
                      />
                    }
                    label="Destinations"
                  />
                </FormGroup>
              </>
            ) : (
              ""
            )}
            {props.reportName == "gri" ? (
              <div style={{ paddingLeft: "2vw", paddingTop: "2vh" }}>
                <strong style={{ fontSize: "1.1rem", paddingLeft: "30px" }}>
                  GRI 1: Foundation 2021
                </strong>{" "}
                &nbsp; &nbsp;
                {/* <a
                  href="https://www.globalreporting.org/how-to-use-the-gri-standards/gri-standards-english-language/"
                  target="_blank"
                > */}
                <IconButton
                  onClick={(e) => setOpenDialog(true)}
                  className="pw-cursor-pointer"
                >
                  <InfoIcon sx={{ color: green[500] }} />
                </IconButton>
                {/* </a> */}
              </div>
            ) : (
              ""
            )}
            {Object.keys(disclosures)?.map((disclosureName, index) => {
              return disclosuresArray.includes(disclosureName) ? (
                <div
                  key={disclosureName + index}
                  style={{ paddingLeft: "2vw", paddingTop: "2vh" }}
                >
                  <DisclosureCollapse
                    update={updateUi}
                    disclosures={disclosures}
                    disclosure={disclosures[disclosureName]}
                    disclosureName={disclosureName}
                    disclosuresArray={disclosuresArray}
                    setDisclosuresArray={setDisclosuresArray}
                    reportName={props.reportName}
                  />
                </div>
              ) : (
                ""
              );
            })}
          </div>
          {disclaimerExpanded && props.reportName == "gri" ? (
            <div style={{ position: "relative", background: "white" }}>
              <div className="mt-4 pb-2 text-justify">
                <div
                  onClick={(e) => setDisclaimerExpanded(false)}
                  style={{
                    cursor: "pointer",
                    textAlign: "right",
                    marginTop: "5px",
                  }}
                >
                  <CancelIcon />
                </div>
                <div className="text-black text-sm mb-2  pl-10 pr-10">
                  <b>Disclaimer:</b> For the latest version of the GRI
                  Standards, including the revised Universal Standards, adapted
                  Topic Standards, Sector Standards, their recommendations and
                  guidance sections, as well as the GRI Standards Glossary,
                  please visit
                  <a
                    href="https://www.globalreporting.org/how-to-use-the-gri-standards/resource-center/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 underline ml-1"
                  >
                    GRI Resource center
                  </a>
                  .
                </div>
                <div className="text-black text-sm pl-10 pr-10">
                  The GRI Standards are used by PlanetWise Pte. Ltd. under
                  licensed authority from GRI. GRI, as Licensor of the copyright
                  in the GRI Standards, verified and validated the authentic and
                  accurate representation of the GRI Standards in PlanetWise.
                  This verification was limited to ensuring the maintenance of
                  the integrity, authenticity and accuracy of the Licensed
                  Content. GRI therefore makes no implied or actual
                  representations or warranties as to the correctness,
                  compliance, trustworthiness, fitness of purpose or quality of
                  PlanetWise or any products resulting therefrom; or of
                  Licensee’s use of the GRI copyrighted content; and expressly
                  disclaims any implied or express representations that any
                  report produced by Licensee meets the standards of an approved
                  GRI Standards Report.
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          <div
            className="pb-5"
            style={{
              position: "absolute",
              bottom: "0px",
              left: "-24px",
              background: "white",
              width: "calc(100% + 48px)",
              display: "flex",
              justifyContent: "space-between",
              paddingLeft: "10px",
              paddingTop: "10px",
              paddingRight: "20px",
            }}
          >
            <div style={{ display: "flex" }}>
              {" "}
              {props.reportName == "gri" ? (
                <div
                  style={{ cursor: "pointer", display: "flex" }}
                  onClick={(e) => setDisclaimerExpanded(!disclaimerExpanded)}
                >
                  <div>{disclaimerExpanded ? "Hide" : "Show"} Disclaimer </div>
                  <div>
                    {disclaimerExpanded ? (
                      <ExpandMoreIcon />
                    ) : (
                      <ExpandLessIcon />
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <Button
              disabled={!enableSave}
              onClick={handleSave}
              style={{ float: "right", color: "white", marginRight: "5vw" }}
              variant="contained"
            >
              {isUpdate ? "Update" : "Save"}
            </Button>
          </div>
        </div>
      ) : (
        <div></div>
      )}

      <Dialog open={openDialog} className="pw-disclosure-dialog">
        <div
          onClick={(e) => setOpenDialog(false)}
          style={{
            cursor: "pointer",
            textAlign: "right",
            marginTop: "5px",
          }}
        >
          <CancelIcon />
        </div>
        <div style={{ height: "90vh" }}>
          <iframe
            width="100%"
            height="100%"
            src="https://cms-asset-files.s3.ap-southeast-1.amazonaws.com/gri/GRI-1-Foundation-2021.pdf#toolbar=0&view=FItH"
          ></iframe>
        </div>
      </Dialog>
    </>
  );
};

export default Disclosures;
